import {createFileRoute} from "@tanstack/react-router"
import Docs from "@/components/Docs/Docs.tsx";

export const Route = createFileRoute("/_mainLayout/legal/")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Docs/>
  );
}
